export default {"src":"/_next/static/media/well-done.mono.0452e1d1.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};